import { error } from "console";
import { GET_PERMISSION_FAILURE, GET_PERMISSION_SUCCESS, RESET_PERMISSION } from "../constants/setInitialPermission.constant";

const initialState = {
    loading: false,
    data: [],
    noPermission: false
};

export const permissionsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_PERMISSION_SUCCESS: {
            return {
                ...state,
                loading: false,
                data: action.payload,
                noPermission: false
            }
        }

        case GET_PERMISSION_FAILURE: {
            return {
                ...state,
                loading: false,
                data: null,
                noPermission: true
            }
        }

        case RESET_PERMISSION: {
            return {
                ...state,
                loading: false,
                data: [],
                noPermission: false
            }
        }

        default: return state
    }
}
